"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accessorForReference = function (columnReference) {
    return function (row) { return row[columnReference.column]; };
};
exports.throwIfUndefined = function (accessor, message) {
    if (message === void 0) { message = 'Accessor returned undefined'; }
    return function (row) {
        var v = accessor(row);
        if (v === undefined) {
            throw new Error(message);
        }
        return v;
    };
};
exports.undefinedToNull = function (accessor) {
    return function (row) { var _a; return _a = accessor(row), (_a !== null && _a !== void 0 ? _a : null); };
};
exports.DefaultMeasureAccessor = function (row) { return row.measure; };
exports.DefaultTimestampAccessor = function (row) { return row.timestamp; };
//# sourceMappingURL=Accessor.js.map